<template>
    <a
        href="#"
        tabindex="-1"
        class="m-0 ms-2 text-danger small"
    >
        <IconComp icon="fa-circle-exclamation" />
    </a>
</template>
<script lang="ts" setup>
import { IconComp } from '@/components';
</script>
